import React, { useEffect, useState, memo, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, ChevronDown, ChevronUp, Clock, ShieldCheck, Star, Users, BookOpen, HeartHandshake, AlertTriangle, LineChart, Check, Sparkles } from 'lucide-react';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/2kkp91DtMBAvZZkeo5BbWJ/Diseno_sin_titulo_(44).png';
const TESTIMONIAL_IMAGES = ['https://cdn.magicpatterns.com/uploads/jtpXq22nRhARXMhftD2aBc/WhatsApp_Image_2026-06-29_at_20.09.27.jpg', 'https://cdn.magicpatterns.com/uploads/b76PoC721RNhWA4P3sbGxK/WhatsApp_Image_2026-06-29_at_20.07.11.jpg', 'https://cdn.magicpatterns.com/uploads/kuVWAuaTmVpSntZwHmi9BA/WhatsApp_Image_2026-06-29_at_20.06.46.jpg', 'https://cdn.magicpatterns.com/uploads/i41MQt6Fa1XSshboSwAMjc/WhatsApp_Image_2026-06-29_at_20.06.19.jpg'];
const CHECKOUT_LINK = 'https://checkout.sectordigital.online/cart/44272367370283:1';
const UPSELL_IMAGE = 'https://cdn.magicpatterns.com/uploads/gDcueV97VcqGuTcFaBJqXs/¡Gracias_por_su_compra_adolesc2Bansydepr.png';
const OFFERS = [{
  id: 'kit',
  title: 'KIT Psicología en Adolescencia',
  oldPrice: '$49.990',
  price: '$19.990',
  url: 'https://checkout.sectordigital.online/cart/44272367370283:1',
  badge: false,
  image: MAIN_IMAGE,
  includes: ['Guía Principal: KIT Psicología en Adolescencia', 'BONUS #1: Guía para Orientar a Familias', 'BONUS #2: Plantillas de Seguimiento Clínico']
}, {
  id: 'ansiedad',
  title: 'Ansiedad y Depresión en Adolescentes',
  oldPrice: '$69.990',
  price: '$29.990',
  url: 'https://checkout.sectordigital.online/cart/44281130057771:1',
  badge: true,
  image: UPSELL_IMAGE,
  includes: ['Todo lo del KIT Psicología en Adolescencia', 'Guía Clínica: Ansiedad y Depresión Adolescente™', 'BONUS #1: Guía para Orientar a Familias', 'BONUS #2: Plantillas de Seguimiento Clínico']
}];
const scrollToPricing = (e?: React.MouseEvent) => {
  if (e) e.preventDefault();
  const target = document.getElementById('countdown-compra') || document.getElementById('compra');
  target?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};
const BuyButton = ({
  className = '',
  onClick
}: {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}) => <button onClick={onClick || scrollToPricing} className={`bg-amber-400 hover:bg-amber-300 text-blue-950 font-bold py-4 px-8 rounded-full shadow-lg transform transition hover:scale-105 text-lg md:text-xl w-full max-w-md mx-auto block text-center ${className}`} data-id="element-0">
    SÍ, QUIERO EL KIT AHORA
  </button>;
const getTimeUntilMidnight = () => {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0); // 00:00 of the next day (end of current day)
  const diff = Math.max(0, midnight.getTime() - now.getTime());
  const totalSeconds = Math.floor(diff / 1000);
  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor(totalSeconds % 3600 / 60),
    seconds: totalSeconds % 60
  };
};
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState(getTimeUntilMidnight);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeUntilMidnight());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-red-600 text-white p-3 rounded-xl shadow-inner text-center mb-5 max-w-md mx-auto" data-id="element-1">
      <p className="font-bold text-xs uppercase tracking-wider mb-1.5" data-id="element-2">
        OFERTA TERMINA EN:
      </p>
      <div className="flex justify-center space-x-4 text-2xl font-black tabular-nums" data-id="element-3">
        <div className="flex flex-col items-center" data-id="element-4">
          <span data-id="element-5">{String(timeLeft.hours).padStart(2, '0')}</span>
          <span className="text-xs font-normal" data-id="element-6">HS</span>
        </div>
        <span data-id="element-7">:</span>
        <div className="flex flex-col items-center" data-id="element-8">
          <span data-id="element-9">{String(timeLeft.minutes).padStart(2, '0')}</span>
          <span className="text-xs font-normal" data-id="element-10">MIN</span>
        </div>
        <span data-id="element-11">:</span>
        <div className="flex flex-col items-center" data-id="element-12">
          <span data-id="element-13">{String(timeLeft.seconds).padStart(2, '0')}</span>
          <span className="text-xs font-normal" data-id="element-14">SEG</span>
        </div>
      </div>
    </div>;
};
const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: ''
  });
  const names = ['Laura M.', 'Sofía G.', 'Julieta R.', 'Martina P.', 'Florencia C.', 'Camila V.', 'Lucía F.'];
  const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán'];
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setPurchaseData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialDelay = setTimeout(showPopup, 10000);
    const interval = setInterval(showPopup, 25000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-15">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 bg-white rounded-lg shadow-2xl border border-gray-100 p-4 z-50 max-w-xs flex items-start space-x-4" data-id="element-16">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-17">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-18" />
          </div>
          <div data-id="element-19">
            <div className="bg-green-600 text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wider inline-block mb-1" data-id="element-20">
              Compra Verificada
            </div>
            <p className="text-sm text-gray-800 font-medium" data-id="element-21">
              {purchaseData.name} de {purchaseData.city}
            </p>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-22">
              Compró KIT Psicología en Adolescencia hace unos minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
const ModuleAccordion = ({
  num,
  title,
  desc
}: {
  num: string;
  title: string;
  desc: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-xl overflow-hidden bg-white hover:border-blue-200 transition-colors" data-id="element-23">
      <button className="flex items-center gap-3 w-full text-left p-4" onClick={() => setIsOpen(!isOpen)} data-id="element-24">
        <span className="flex-shrink-0 w-10 h-10 bg-blue-100 text-blue-700 rounded-full flex items-center justify-center font-black text-base" data-id="element-25">
          {num}
        </span>
        <span className="flex-1 font-bold text-base text-gray-900" data-id="element-26">
          {title}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 flex-shrink-0 text-gray-500" data-id="element-27" /> : <ChevronDown className="w-5 h-5 flex-shrink-0 text-gray-500" data-id="element-28" />}
      </button>
      <AnimatePresence data-id="element-29">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-30">
            <p className="px-4 pb-4 text-gray-600 text-sm leading-relaxed" data-id="element-31">
              {desc}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
const FaqItem = ({
  question,
  answer
}: {
  question: string;
  answer: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 py-4" data-id="element-32">
      <button className="flex justify-between items-center w-full text-left font-semibold text-gray-800 hover:text-blue-600 transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-33">
        <span className="pr-4" data-id="element-34">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 flex-shrink-0" data-id="element-35" /> : <ChevronDown className="w-5 h-5 flex-shrink-0" data-id="element-36" />}
      </button>
      <AnimatePresence data-id="element-37">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-38">
            <div className="pt-4 text-gray-600 text-sm leading-relaxed" data-id="element-39">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export function App() {
  const [selectedOffer, setSelectedOffer] = useState('ansiedad');
  const activeOffer = OFFERS.find(o => o.id === selectedOffer) || OFFERS[0];
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '26257470350562748');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-800 selection:bg-blue-200" data-id="element-40">
      {/* HEADER / HERO */}
      <header className="bg-gradient-to-b from-blue-900 to-blue-800 text-white min-h-[100dvh] flex flex-col justify-center px-4 py-10 text-center" data-id="element-41">
        <div className="max-w-3xl mx-auto" data-id="element-42">
          <p className="text-blue-200 font-semibold tracking-widest uppercase text-xs md:text-sm mb-2 md:mb-3" data-id="element-43">
            KIT Psicología en Adolescencia™
          </p>
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight mb-4" data-id="element-44">
            DEJÁ DE IMPROVISAR TUS SESIONES CON ADOLESCENTES
          </h1>
          <img src={MAIN_IMAGE} alt="KIT Psicología en Adolescencia" className="w-[78%] sm:w-[50%] max-w-[288px] mx-auto mb-4 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" onClick={scrollToPricing} data-id="element-45" />
          <p className="text-base md:text-xl text-amber-400 mb-4 max-w-2xl mx-auto font-semibold" data-id="element-46">
            Conducí sesiones con más estructura, claridad y criterio clínico.
          </p>

          <p className="text-sm md:text-base text-blue-50 mb-5 max-w-2xl mx-auto" data-id="element-47">
            El sistema práctico para psicólogos que quieren ordenar la
            evaluación, el vínculo terapéutico, el trabajo con familias, la
            intervención, el seguimiento y el abordaje de procesos complejos con
            adolescentes.
          </p>

          <BuyButton className="!py-3 !text-base md:!text-lg" data-id="element-48" />
          <p className="mt-3 text-xs md:text-sm text-blue-200 flex items-center justify-center gap-2" data-id="element-49">
            <Clock className="w-4 h-4" data-id="element-50" /> Acceso inmediato ·{' '}
            <ShieldCheck className="w-4 h-4" data-id="element-51" /> Pago único y seguro
          </p>
        </div>
      </header>

      {/* PROBLEM / SOLUTION */}
      <section className="py-20 px-4 bg-white" data-id="element-52">
        <div className="max-w-4xl mx-auto text-center" data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-54">
            UN SISTEMA PARA TRABAJAR CON ADOLESCENTES CON MÁS ORDEN CLÍNICO
          </h2>
          <p className="text-lg text-gray-600 mb-12 max-w-3xl mx-auto" data-id="element-55">
            Creamos un sistema claro y aplicable para que dejes de conducir
            sesiones con adolescentes desde la improvisación, la intuición o la
            urgencia del momento… y empieces a trabajar cada proceso con una
            estructura clínica concreta desde la primera consulta hasta el
            seguimiento terapéutico.
          </p>

          <div className="grid md:grid-cols-3 gap-8 text-left" data-id="element-56">
            <div className="bg-blue-50 p-6 rounded-2xl" data-id="element-57">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 text-blue-600" data-id="element-58">
                <CheckCircle2 className="w-6 h-6" data-id="element-59" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-60">
                MÁS CLARIDAD DESDE EL INICIO
              </h3>
              <p className="text-gray-600" data-id="element-61">
                Sabés qué evaluar, qué preguntar, qué observar y cómo
                diferenciar la demanda familiar de la demanda real del
                adolescente.
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-2xl" data-id="element-62">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 text-blue-600" data-id="element-63">
                <ShieldCheck className="w-6 h-6" data-id="element-64" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-65">
                MÁS SEGURIDAD PROFESIONAL
              </h3>
              <p className="text-gray-600" data-id="element-66">
                Tenés criterios para vínculo terapéutico, confidencialidad,
                familia, conducta, redes, riesgo, crisis y continuidad del
                proceso.
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-2xl" data-id="element-67">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mb-4 text-blue-600" data-id="element-68">
                <BookOpen className="w-6 h-6" data-id="element-69" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-70">
                MÁS ESTRUCTURA EN CADA ETAPA
              </h3>
              <p className="text-gray-600" data-id="element-71">
                No es teoría abstracta. Son guías, preguntas, pautas, criterios
                y recursos prácticos para aplicar en el trabajo clínico real.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* MODULES */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-72">
        <div className="max-w-4xl mx-auto" data-id="element-73">
          <div className="text-center mb-16" data-id="element-74">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-75">
              QUÉ INCLUYE KIT PSICOLOGÍA EN ADOLESCENCIA
            </h2>
            <p className="text-lg text-gray-600" data-id="element-76">
              Todo lo que necesitás para estructurar el abordaje clínico con
              adolescentes desde la primera consulta hasta el seguimiento del
              proceso terapéutico.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-12" data-id="element-77">
            <div className="bg-blue-900 text-white p-6 md:p-8 text-center" data-id="element-78">
              <h3 className="text-2xl font-bold mb-2" data-id="element-79">
                Guía Principal: KIT Psicología en Adolescencia
              </h3>
              <p className="text-blue-100" data-id="element-80">
                El sistema completo para ordenar sesiones con adolescentes,
                orientar a familias y sostener procesos terapéuticos complejos.
              </p>
            </div>

            <div className="p-6 md:p-8" data-id="element-81">
              <h4 className="font-bold text-xl text-center mb-8 text-gray-800" data-id="element-82">
                Sistema Psicología en Adolescencia™ en 7 módulos
              </h4>

              <div className="grid md:grid-cols-2 gap-4" data-id="element-83">
                {[{
                num: '01',
                title: 'Evaluación inicial del adolescente',
                desc: 'Protocolo para ordenar la primera consulta. Motivo de consulta, demanda familiar, demanda del adolescente, áreas clínicas a explorar y primeros objetivos terapéuticos.'
              }, {
                num: '02',
                title: 'Construcción del vínculo terapéutico',
                desc: 'Sistema para trabajar con adolescentes que llegan obligados, responden poco, se muestran cerrados o no encuentran sentido al espacio terapéutico.'
              }, {
                num: '03',
                title: 'Trabajo con familia y entorno',
                desc: 'Guía para orientar madres, padres y cuidadores sin invadir el espacio del adolescente. Confidencialidad, límites, acuerdos familiares y participación del entorno.'
              }, {
                num: '04',
                title: 'Regulación emocional y conducta',
                desc: 'Herramientas para intervenir en enojo, angustia, ansiedad, impulsividad, aislamiento, baja tolerancia a la frustración y conductas problemáticas.'
              }, {
                num: '05',
                title: 'Redes, autoimagen y vínculos sociales',
                desc: 'Criterios para explorar redes sociales, comparación, validación externa, bullying, ciberbullying, pertenencia, autoestima y vínculos de pares.'
              }, {
                num: '06',
                title: 'Riesgo, crisis y señales de alerta',
                desc: 'Mapa clínico para detectar autolesiones, ideación suicida, consumo, violencia, abuso, aislamiento extremo y situaciones que requieren derivación o interconsulta.'
              }, {
                num: '07',
                title: 'Continuidad terapéutica y seguimiento',
                desc: 'Sistema para prevenir abandonos, revisar objetivos, detectar estancamientos, registrar avances y decidir cuándo continuar, ajustar, derivar, pausar o cerrar.'
              }].map((mod, idx) => <ModuleAccordion key={idx} num={mod.num} title={mod.title} desc={mod.desc} data-id="element-84" />)}
              </div>
            </div>
          </div>

          <BuyButton data-id="element-85" />
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-20 px-4 bg-blue-900 text-white relative overflow-hidden" data-id="element-86">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '32px 32px'
      }} data-id="element-87"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-88">
          <div className="text-center mb-12" data-id="element-89">
            <div className="inline-block bg-yellow-400 text-yellow-900 font-black px-4 py-1 rounded-full text-sm uppercase tracking-widest mb-4" data-id="element-90">
              ¡GRATIS POR EL DÍA DE HOY!
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-91">
              OFERTA ESPECIAL: BONUS PROFESIONALES INCLUIDOS CON TU COMPRA
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-92">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-8 rounded-2xl" data-id="element-93">
              <div className="bg-yellow-400 text-yellow-900 text-xs font-bold px-3 py-1 rounded-full inline-block mb-4" data-id="element-94">
                ¡Incluido hoy!
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-95">
                BONUS #1 — Guía para Orientar a Familias
              </h3>
              <p className="text-blue-100 mb-4 text-sm" data-id="element-96">
                Documento práctico para usar como apoyo al momento de orientar
                madres, padres o cuidadores de adolescentes.
              </p>
              <ul className="space-y-3 mb-6 text-sm text-blue-50" data-id="element-97">
                <li className="flex gap-2" data-id="element-98">
                  <Check className="w-5 h-5 text-yellow-400 flex-shrink-0" data-id="element-99" />{' '}
                  cómo explicar confidencialidad sin romper el vínculo
                  terapéutico;
                </li>
                <li className="flex gap-2" data-id="element-100">
                  <Check className="w-5 h-5 text-yellow-400 flex-shrink-0" data-id="element-101" />{' '}
                  qué compartir con la familia y qué preservar del espacio del
                  adolescente;
                </li>
                <li className="flex gap-2" data-id="element-102">
                  <Check className="w-5 h-5 text-yellow-400 flex-shrink-0" data-id="element-103" />{' '}
                  frases útiles para familias ansiosas, invasivas, ausentes o
                  confrontativas.
                </li>
              </ul>
              <p className="text-sm font-semibold text-yellow-300" data-id="element-104">
                Para que el psicólogo tenga una guía concreta para acompañar a
                la familia sin convertirla en supervisora del tratamiento.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-8 rounded-2xl" data-id="element-105">
              <div className="bg-yellow-400 text-yellow-900 text-xs font-bold px-3 py-1 rounded-full inline-block mb-4" data-id="element-106">
                ¡Incluido hoy!
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-107">
                BONUS #2 — Plantillas de Seguimiento Clínico
              </h3>
              <p className="text-blue-100 mb-4 text-sm" data-id="element-108">
                Registros editables para ordenar objetivos, evolución, señales
                de alerta, acuerdos familiares, asistencia y próximos pasos
                terapéuticos.
              </p>
              <ul className="space-y-3 mb-6 text-sm text-blue-50" data-id="element-109">
                <li className="flex gap-2" data-id="element-110">
                  <Check className="w-5 h-5 text-yellow-400 flex-shrink-0" data-id="element-111" />{' '}
                  evaluación inicial, áreas afectadas y formulación del caso;
                </li>
                <li className="flex gap-2" data-id="element-112">
                  <Check className="w-5 h-5 text-yellow-400 flex-shrink-0" data-id="element-113" />{' '}
                  seguimiento por sesión, regulación emocional y señales de
                  riesgo;
                </li>
                <li className="flex gap-2" data-id="element-114">
                  <Check className="w-5 h-5 text-yellow-400 flex-shrink-0" data-id="element-115" />{' '}
                  acuerdos familiares, evolución global y criterios de ajuste,
                  derivación o cierre.
                </li>
              </ul>
              <p className="text-sm font-semibold text-yellow-300" data-id="element-116">
                Para que no tengas que sostener todo desde la memoria y puedas
                conducir el proceso con más claridad, registro y continuidad.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="compra" className="min-h-[100dvh] flex items-center justify-center py-10 px-4 bg-gray-50" data-id="element-117">
        <div id="card-compra" className="max-w-md w-full mx-auto scroll-mt-4" data-id="element-118">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-119">
            <div className="bg-blue-900 p-5 text-center text-white" data-id="element-120">
              <h2 className="text-xl md:text-2xl font-bold mb-1" data-id="element-121">
                ESTRUCTURÁ TUS SESIONES CON ADOLESCENTES
              </h2>
              <p className="text-blue-200 text-sm" data-id="element-122">
                Un solo pago. Tuyo para siempre.
              </p>
            </div>

            <div className="p-5" data-id="element-123">
              <div id="countdown-compra" className="scroll-mt-4" data-id="element-124">
                <CountdownTimer data-id="element-125" />
              </div>

              <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-2xl p-4 mb-5" data-id="element-126">
                <Sparkles className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-127" />
                <p className="text-sm text-gray-700 leading-snug text-left" data-id="element-128">
                  Sumá el libro{' '}
                  <span className="font-bold text-gray-900" data-id="element-129">
                    "Ansiedad y Depresión"
                  </span>{' '}
                  y trabajá con más criterio dos de los espectros más frecuentes
                  en la adolescencia.
                </p>
              </div>

              <AnimatePresence mode="wait" data-id="element-130">
                <motion.img key={activeOffer.id} src={activeOffer.image} alt={activeOffer.title} initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} exit={{
                opacity: 0
              }} transition={{
                duration: 0.2
              }} className="w-1/2 max-w-[200px] mx-auto mb-4" data-id="element-131" />
              </AnimatePresence>

              <div className="space-y-3 mb-5" data-id="element-132">
                {OFFERS.map(offer => {
                const isSelected = selectedOffer === offer.id;
                return <div key={offer.id} className="relative" data-id="element-133">
                      {offer.badge && <div className="absolute -top-2 right-4 z-10 bg-amber-400 text-blue-950 text-[10px] font-black px-2 py-0.5 rounded-full uppercase tracking-wider flex items-center gap-1" data-id="element-134">
                          <Star className="w-3 h-3 fill-current" data-id="element-135" /> Más elegida
                        </div>}
                      <button type="button" onClick={() => setSelectedOffer(offer.id)} className={`w-full flex items-center gap-3 text-left rounded-2xl border-2 p-4 transition-colors ${isSelected ? 'border-amber-400 bg-amber-50' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-136">
                        <span className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${isSelected ? 'border-amber-400 bg-amber-400' : 'border-gray-300'}`} data-id="element-137">
                          {isSelected && <Check className="w-4 h-4 text-white" data-id="element-138" />}
                        </span>
                        <span className="flex-1 font-bold text-sm text-gray-900 leading-tight" data-id="element-139">
                          {offer.title}
                        </span>
                        <span className="text-right leading-tight" data-id="element-140">
                          <span className="block text-xs text-gray-400 line-through font-semibold" data-id="element-141">
                            {offer.oldPrice}
                          </span>
                          <span className="block text-lg font-black text-gray-900" data-id="element-142">
                            {offer.price}
                          </span>
                        </span>
                      </button>
                    </div>;
              })}
              </div>

              <div className="bg-gray-50 rounded-2xl border border-gray-100 p-4 mb-5" data-id="element-143">
                <p className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3" data-id="element-144">
                  Incluye:
                </p>
                <AnimatePresence mode="wait" data-id="element-145">
                  <motion.ul key={activeOffer.id} initial={{
                  opacity: 0
                }} animate={{
                  opacity: 1
                }} exit={{
                  opacity: 0
                }} transition={{
                  duration: 0.2
                }} className="space-y-2 text-left" data-id="element-146">
                    {activeOffer.includes.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-gray-700 text-sm font-medium" data-id="element-147">
                        <Check className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-148" />
                        {item}
                      </li>)}
                  </motion.ul>
                </AnimatePresence>
              </div>

              <div className="bg-blue-900 rounded-2xl p-5 text-center text-white" data-id="element-149">
                <div className="flex justify-center items-center gap-3 mb-4" data-id="element-150">
                  <span className="text-xl text-blue-300 line-through font-bold" data-id="element-151">
                    {activeOffer.oldPrice}
                  </span>
                  <span className="text-4xl font-black text-green-400" data-id="element-152">
                    {activeOffer.price}
                  </span>
                  <span className="text-blue-200 text-xs self-end mb-1" data-id="element-153">
                    ARS
                  </span>
                </div>

                <BuyButton className="w-full !text-base !py-3 mb-4" onClick={() => window.location.href = activeOffer.url} data-id="element-154" />

                <div className="flex justify-center items-center gap-3 text-xs text-blue-100 font-medium flex-wrap" data-id="element-155">
                  <span className="flex items-center gap-1" data-id="element-156">
                    <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-157" /> Pago
                    único
                  </span>
                  <span className="flex items-center gap-1" data-id="element-158">
                    <Clock className="w-4 h-4 text-green-400" data-id="element-159" /> Acceso
                    inmediato
                  </span>
                  <span className="flex items-center gap-1" data-id="element-160">
                    <CheckCircle2 className="w-4 h-4 text-green-400" data-id="element-161" /> Garantía
                    7 días
                  </span>
                </div>
                <div className="flex justify-center items-center gap-1 text-xs text-blue-100 font-medium mt-2" data-id="element-162">
                  <Star className="w-4 h-4 text-yellow-400 fill-current" data-id="element-163" /> +500
                  profesionales
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-20 px-4 bg-white" data-id="element-164">
        <div className="max-w-5xl mx-auto" data-id="element-165">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-166">
            Lo que dicen otros profesionales
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-167">
            {/* Text Testimonials */}
            <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100" data-id="element-168">
              <div className="flex text-yellow-400 mb-4" data-id="element-169">
                <Star className="w-5 h-5 fill-current" data-id="element-170" />
                <Star className="w-5 h-5 fill-current" data-id="element-171" />
                <Star className="w-5 h-5 fill-current" data-id="element-172" />
                <Star className="w-5 h-5 fill-current" data-id="element-173" />
                <Star className="w-5 h-5 fill-current" data-id="element-174" />
              </div>
              <p className="text-gray-700 italic mb-6" data-id="element-175">
                "Me cambió por completo la forma de encarar la primera sesión.
                Antes sentía que la familia me marcaba la cancha y me costaba
                conectar con el adolescente. El módulo de vínculo terapéutico y
                las plantillas son oro puro. Super recomendable."
              </p>
              <div className="flex items-center gap-3" data-id="element-176">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-700 font-bold" data-id="element-177">
                  ML
                </div>
                <div data-id="element-178">
                  <p className="font-bold text-gray-900" data-id="element-179">Mariana L.</p>
                  <p className="text-xs text-gray-500" data-id="element-180">
                    Psicóloga Clínica, CABA
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100" data-id="element-181">
              <div className="flex text-yellow-400 mb-4" data-id="element-182">
                <Star className="w-5 h-5 fill-current" data-id="element-183" />
                <Star className="w-5 h-5 fill-current" data-id="element-184" />
                <Star className="w-5 h-5 fill-current" data-id="element-185" />
                <Star className="w-5 h-5 fill-current" data-id="element-186" />
                <Star className="w-5 h-5 fill-current" data-id="element-187" />
              </div>
              <p className="text-gray-700 italic mb-6" data-id="element-188">
                "Buscaba algo práctico y esto superó mis expectativas. No es
                teoría aburrida, son herramientas que aplicás al día siguiente
                en el consultorio. La guía para orientar a padres me salvó de
                varias situaciones incómodas. Excelente inversión."
              </p>
              <div className="flex items-center gap-3" data-id="element-189">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-700 font-bold" data-id="element-190">
                  PG
                </div>
                <div data-id="element-191">
                  <p className="font-bold text-gray-900" data-id="element-192">Pablo G.</p>
                  <p className="text-xs text-gray-500" data-id="element-193">Psicólogo, Córdoba</p>
                </div>
              </div>
            </div>
          </div>

          {/* Image Testimonials */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-194">
            {TESTIMONIAL_IMAGES.map((img, idx) => <img key={idx} src={img} alt="Testimonio real" className="w-full rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-195" />)}
          </div>
        </div>
      </section>

      {/* FAQS */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-196">
        <div className="max-w-3xl mx-auto" data-id="element-197">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-198">
            Preguntas Frecuentes
          </h2>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 md:p-8" data-id="element-199">
            <FaqItem question="¿El pago es único?" answer="Sí, el pago es único. No hay suscripciones ni cobros mensuales. Abonás una sola vez y tenés acceso al material para siempre, incluyendo todas las futuras actualizaciones que hagamos del KIT." data-id="element-200" />
            <FaqItem question="¿Cómo recibo el material?" answer={<span data-id="element-202">
                  <strong data-id="element-203">El proceso es automático e inmediato.</strong> Al
                  realizar la compra, ingresás tu correo electrónico. Una vez
                  aprobado el pago, el contenido te llega directamente a ese
                  mail. <br data-id="element-204" />
                  <br data-id="element-205" />
                  <em data-id="element-206">Importante:</em> Revisá siempre tu bandeja de SPAM o
                  Promociones por las dudas. Ante cualquier inconveniente, podés
                  comunicarte con nosotros a{' '}
                  <strong data-id="element-207">sectordigital53@gmail.com</strong> y te ayudamos
                  enseguida.
                </span>} data-id="element-201" />
            <FaqItem question="¿Reemplaza una formación o supervisión profesional?" answer="No. El KIT es una herramienta práctica y un complemento clínico diseñado para ordenar y estructurar tu trabajo. No reemplaza la formación académica de grado, posgrado ni los espacios de supervisión clínica que son fundamentales en nuestra profesión." data-id="element-208" />
            <FaqItem question="¿Para qué edades aplica este KIT?" answer="El sistema está pensado para el abordaje clínico de adolescentes, abarcando generalmente la franja etaria desde los 12-13 años hasta los 18-19 años. Las herramientas son adaptables según la madurez y particularidades de cada paciente." data-id="element-209" />
            <FaqItem question="¿Puedo imprimir el material?" answer="¡Sí, totalmente! El material se entrega en formato digital (PDF) de alta calidad, listo para que lo leas en cualquier dispositivo (celular, tablet, computadora) o lo imprimas si preferís trabajar con el formato físico en tu consultorio." data-id="element-210" />
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-211">
        <div className="max-w-4xl mx-auto" data-id="element-212">
          <p className="mb-4" data-id="element-213">
            © 2026 KIT Psicología en Adolescencia. Todos los derechos
            reservados.
          </p>
          <p className="text-xs text-gray-500 max-w-2xl mx-auto" data-id="element-214">
            Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
            este sitio NO está respaldado por Facebook de ninguna manera.
          </p>
        </div>
      </footer>

      <PurchasePopup data-id="element-215" />
    </div>;
}